import {lazy, trigger, filter, switchOutput} from './lang.js';

export const threshold = (getter, thresholdValue, switchTime) => {
    // wait until data goes to switch
    var data = 0;
    var switching = false;
    var timeSwitched = 0;

    return (stepData, stepNumber, time) => {
        if (stepData === undefined) {
            return filter(false);
        }

        if (!switching) {
            data += getter(stepData, stepNumber, time);
            if (data >= lazy(thresholdValue)) {
                data = 0;
                switching = true;
                timeSwitched = 0;
            }
        }
  
        if (switching) {
            timeSwitched++;
            if (timeSwitched >= lazy(switchTime)) {
                switching = false;
            }
            return switchOutput(1);
        } 

        return switchOutput(0);
    };
};
